import React from "react";
import Api from "../../../services/Api";
import { Icon } from "@fluentui/react/lib/Icon";
import {
  IPersonaSharedProps,
  PersonaInitialsColor,
  Persona,
  PersonaSize,
} from "@fluentui/react/lib/Persona";

class OwnerChange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newOwner: null,
    };
  }

  // _mapNewOwnerForPersona(users) {
  //   return users.length ? users.map((x) => x.DisplayName) : "None";
  // }

  _mapNewOwnerForPersona(users) {
  return users && users.length
    ? users
        .filter((x) => x && typeof x.DisplayName === "string")
        .map((x) => x.DisplayName)
        .join(", ")
    : "None";
}



  // _mapOwnerForPersona(users) {
  //   //let names = users.map(x => x.displayName).join(', ');
  //   return users.length ? users.map((x) => x.displayName) : "None";
  // }

  _mapOwnerForPersona(users) {
  return users && users.length
    ? users
        .filter((x) => x && typeof x.displayName === "string")
        .map((x) => x.displayName)
        .join(", ")
    : "None";
}

  componentDidMount(): void {
    // this.getNewOwner(this.props.newOwner)
  }

  getNewOwner(userId) {
    Api.get(`User/GetUserById?userId=${userId}`)
      .then((res) => res.data)
      .then((user) => {
        this.setState({ newOwner: [user] });
      });
  }

  getInitials(name) {
    if (!name) return "";
    let names = name.split(" "),
      initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  }

  render() {
    const sharedProps: IPersonaSharedProps = {
      showSecondaryText: true,
      initialsColor: PersonaInitialsColor.darkBlue,
      size: PersonaSize.size32,
    };

    // let download = [{displayName:"Downloading..."}];
    // let newOwner = this.state.newOwner? this.state.newOwner :  download;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: "10px",
        }}
      >
        <Persona
          {...sharedProps}
          secondaryText="Current Owner"
          text={this._mapOwnerForPersona(this.props.owners)}
          imageInitials={this.getInitials(
            this.props.owners[0] ? this.props.owners[0].displayName : "None",
          )}
        />
        <Icon
          iconName="Down"
          style={{ paddingTop: "5px", paddingBottom: "5px" }}
        />
        <Persona
          {...sharedProps}
          secondaryText="New Owner"
          text={this._mapNewOwnerForPersona([this.props.newOwner])}
          imageInitials={this.getInitials(
            this.props.newOwner ? this.props.newOwner.DisplayName : "None",
          )}
        />
      </div>
    );
  }
}
// const urlStyles = {
//     root: {
//         color: 'rgb(0, 120, 212)'
//     }
// }
// const statusStyles = {
//     padding: '8px 12px',
//     fontSize: '12px'
// }

// const createdByStyles = {
//     padding: '8px 16px 0',
//     fontSize: '12px'
// }

// const btnEditStyles = {
//     root: {
//         margin: '6px',
//         height: '24px',
//         minWidth: '40px'
//     },
//     label: {
//         fontWeight: 400
//     }
// }

// const iconContainerStyles = {
//     display: 'flex',
//     flexDirection:'column'
// }

// const iconStyles = {
//     root: {
//         margin: '10px 10px 10px 0'
//     }
// }

// const attentionIconStyles = {
//     color: 'red'
// }

// const updatesIconStyles = {
//     color: 'orange'
// }

// const titleStyles = {
//     display: 'flex',
//     flexDirection: 'row',
//     justifyContent: 'space-between'
// }

// const cardStyles = {
//     root: {
//         marginRight: 20,
//         marginBottom: 20,
//         width: 400,
//         height:300
//     }
// };

// const detailsStyles = {
//     root: {
//         height: 235
//     }
// }

export default OwnerChange;



// WEBPACK FOOTER //
// ./src/components/ManageCenter/ChangeValues/OwnerChange.js